/**
 * Check if current time is within Pacific Time business hours (5AM - 5PM PT).
 * Uses Intl API to get current hour in America/Los_Angeles timezone.
 */
export function isDuringPacificBusinessHours(): boolean {
  try {
    const now = new Date()
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      hour12: false,
    })
    const hour = parseInt(formatter.format(now), 10)
    return hour >= 5 && hour < 17
  } catch {
    // If Intl API fails, default to not showing
    return false
  }
}
